import React from 'react';
import PropTypes from 'prop-types';

const SrRenterApplicationStatusInviteRoommateRow = ({
  onInviteRoommateClicked,
  listing,
  householdId,
}) => (
  <div
    className="SrRenterApplicationStatusInviteRoommateRow"
    onClick={() => onInviteRoommateClicked({ listing, householdId })}
  >
    <div className="actionContainer">
      <span
        className="actionLink"
        onClick={() => onInviteRoommateClicked({ listing, householdId })}
      />
    </div>
    <div className="textContainer">
      <span className="addRoommate">Add a roommate</span>
      <span className="addRoommateMessage">
        Send a link to your roommate to apply &#38; pay application fees
      </span>
    </div>
  </div>
);

SrRenterApplicationStatusInviteRoommateRow.propTypes = {
  onInviteRoommateClicked: PropTypes.func.isRequired,
  listing: PropTypes.object.isRequired,
};

SrRenterApplicationStatusInviteRoommateRow.displayName =
  'SrRenterApplicationStatusInviteRoommateRow';

export default SrRenterApplicationStatusInviteRoommateRow;
